<ion-content class="container">
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickSetup('Setup')">
        <label class="font_semibold fs-16 ml-10 mt-5 black_color">
          <span class="cp" (click)="onClickSetup('Setup')">Increment / Setup</span> / <span
            [style.color]="buttonColorName">Increment Letter</span></label>
      </div>
    </ion-col>
  </ion-row>
  <div class="modal-body p-20">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <mat-form-field class="w-150 mat-height40 mat-input-style">
          <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="onYearChange($event)">
            <mat-option [value]="item.year"
              *ngFor="let item of getIncrementFyYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
    </ion-row>

    <!-- <ion-row>
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <p class="Company-Letter-head-title">Company Letter head</p>
      </ion-col>
    </ion-row> -->

    <ion-row>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <div class="cardBox mb-20 p-20">
          <!-- <button class="downloadImportFileBtn font_medium mr-30 mt-10" [style.background-color]="buttonColorName" (click)="onClickDownloadLetterHeadFile()">
              <img class="mr-10" src="././assets/icon/downloadWhite.svg">Letter Head Download</button> -->

          <div class="fs-14 font_semibold mt-5 text-center"> Company Letter head </div>
          <div *ngIf="!showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp"
            (click)="browseImage.click()">
            <div class="d-flex text-center">
              <label class="uploadBtn text_center font_regular cp"><span
                  class="material-icons">upload_file</span><br>Browse File</label>
              <input #browseImage type="file" (change)="onFileSelected($event)" style="display:none;">
            </div>
          </div>
          <div *ngIf="showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp">
            <div class="d-flex mb-50 mt-50">
              <div class="verticle-center mr-20">
                <img src="././assets/icon/successImport.svg" width="35px">
              </div>
              <div class="flex-column">
                <label class="fs-14 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                <div class="d-flex">
                  <label class="fs-12 blue font_medium cl-black mx-width"
                    (click)="onClickDownloadLetterHeadFile()">{{fileName}}</label>
                    <span class="removefile">

                      <span class="material-icons close cp  imgRemove "(click)="onCloseFile()" *ngIf="fileName">close</span>
                    </span>

                  <!-- <span class="material-icons fs-12 ml-5" (click)="onCloseFile()" *ngIf="isDisabledImportLetter">close</span> -->
                  <!-- <span class="removefile">

                    <span class="material-icons close cp  imgRemove " title="Remove" (click)="onCloseFile()"
                      *ngIf="isDisabledImportLetter">close</span>

                      
                  </span> -->

                </div>
              </div>
            </div>
          </div>
          <div class="upload-file-validation">
            <p>One file only | 10 MB Limits</p>
            <button type="button" [style.background-color]="buttonColorName" [disabled]="isDisabledLetterHeadBtn"
              (click)="onSendCompanyLetterheadFile()">Save</button>
          </div>
        </div>
      </ion-col>

      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <div class="cardBox  p-20">

          <div class="fs-14 font_semibold mt-5 text-center"> Digital signature</div>
          <div class="w-100 upload-box display-center mt-20 cp" [ngClass]="{'drag-over': isDraggingSign}"
            (dragover)="onDragOverSing($event)" (dragleave)="onDragLeaveSign($event)" (drop)="onFileDroppedSign($event)"
            *ngIf="!showSignBrowseBtn">
            <div class="upload-file-container1">
              <p>Drag and drop a file here </p>
              <p class="mt-5">OR</p>
              <div *ngIf="!showSignBrowseBtn" class="w-100  display-center mt-20 cp" (click)="browseSignImage.click()">
                <button class="browse-btn" (click)="triggerFileInputSign()">Browse</button>
                <input #browseSignImage type="file" (change)="onFileSelectedForSign($event,'sign')"
                  style="display:none;">
              </div>
            </div>

          </div>
          <div *ngIf="showSignBrowseBtn" class="w-100 upload-box display-center mt-20 cp">
            <div class="d-flex mb-20 mt-20">
              <div class="verticle-center mr-20">
                <img src="././assets/icon/successImport.svg" style="width: 35px;margin-bottom: 14px;">
              </div>
              <div class="flex-column">
                <label class="fs-14 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>

                <div class="d-flex">
                  <!-- <label class="fs-12 blue font_medium cl-black mx-width">{{signfileName}}</label> -->
                  <div class="d-flex">
                    <label class="fs-12 blue font_medium cl-black mx-width"
                      (click)="downloadSign(signfileNameForApiAppend)"
                      style="cursor: pointer; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                      title="{{signfileNameForApiAppend}}">
                      {{signfileNameForApiAppend.name ||signfileNameForApiAppend}}
                    </label>
                    <span class="removefile">

                      <span class="material-icons close cp  imgRemove " title="Remove"
                        (click)="onClickCancelUploadletterHead(signfileNameForApiAppend,'sign')">close</span>
                    </span>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="upload-file-validation d-flex">
            <!-- <p style="color: red; margin-left: 10px;"*ngIf="!showSignBrowseBtn"> only image format allowed. </p> -->
            <p>One file only | 2 MB Limits </p>
            <div class="btn-group">
              <!-- <button class="Cancel-btn" (click)="onClickCancelUploadSign()">Cancel</button> -->
              <button class="upload-policy-btn" [style.background-color]="buttonColorName"
                [disabled]="isDisabledUploadPolicyBtnForSign" (click)="onClickUploadSign()">Upload</button>
            </div>
          </div>

        </div>
      </ion-col>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <div class="cardBox  p-20">
          <div class="fs-14 font_semibold mt-5 text-center">Terms And Condition(optional)</div>
          <div class="content-box mt-20">
            <div><img class="w70" src="././assets/icon/content-icon.jpg" alt="createEmailBody"></div>
            <button class="elcm_Btn fs-14" [style.background-color]="buttonColorName"
              (click)="onClickOpenCreatetermandConditon('Add term And Condition for increment')">+
              Create</button>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
        <p class="select-combination">Select the combination for Increment letters</p>
      </ion-col>
         <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
        <p class="select-combination ml-60">Select CTC Annexure Type</p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
        <div class="select-combination-checkbox">
          <section class="mat-checkbox-style">
            <mat-checkbox [(ngModel)]="departmentChecked">Department</mat-checkbox>
            <mat-checkbox [(ngModel)]="bandChecked">Band</mat-checkbox>
            <mat-checkbox [(ngModel)]="ratingChecked">Rating</mat-checkbox>
          </section>
          <button class="create-btn" [style.background-color]="buttonColorName"
            (click)="onClickCreateBtn()" [disabled]="isDisabledIncrementLetter"[ngClass]="{ 'disable': isDisabledIncrementLetter }">Create</button>
        </div>
      </ion-col>
  
      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12" >
         
         <mat-form-field class="w-150 mat-height40 mat-input-style ml-60">
          <mat-select placeholder="Select type" [(ngModel)]="selectedType"  [disabled]="isDisabledIncrementLetter">
            <mat-option *ngFor="let type of CTCComparisonType " [value]="type.key">  {{ type.value }}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="isIncrementLetterCreateContent">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="table-container">

          <!-- only Department -->
          <table class="rating-table" *ngIf="onVisibleDepartmentData">
            <thead>
              <tr>
                <th>Department</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of getDepartmentTableData; let rowId = index">
                <td class="pl-10">{{data}}</td>
                <td>
                  <div class="rating-table-data">
                    <u (click)="onClickAddLetter(rowId, '', data, '', '', letterNames[rowId])">
                      {{ letterNames[rowId] && letterNames[rowId][0] ? letterNames[rowId][0] : '+ Add Letter' }}
                    </u>
                    <div>
                      <span *ngIf="letterNames[rowId]" (click)="removeLetter(rowId, 0, 0, letterNames[rowId])"
                        class="fs-16 mr-10 material-icons">close</span>
                      <span class="fs-20 material-icons rating-table-data-icon"
                        [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                    </div>
                  </div>
                  <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                    <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                          (click)="selectLetter(rowId, letter)">
                          <span class="blue cp">{{ letter.letterName }}</span>
                        </ion-col>
                      </ion-row>
                    </div>
                  </mat-menu>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- only Band -->
          <table class="rating-table" *ngIf="onVisibleBandData">
            <thead>
              <tr>
                <th>Band</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of getBandTableData; let rowId = index">
                <td>
                  <div class="band-table-data pl-10">{{data}}</div>
                </td>
                <td>
                  <div class="rating-table-data">
                    <u (click)="onClickAddLetter(rowId, '', '', 'data', '', letterNames[rowId])">
                      {{ letterNames[rowId] && letterNames[rowId][0] ? letterNames[rowId][0] : '+ Add Letter' }}
                    </u>
                    <div>
                      <span *ngIf="letterNames[rowId]" (click)="removeLetter(rowId, 0, 0, letterNames[rowId])"
                        class="fs-16 mr-10 material-icons">close</span>
                      <span class="fs-20 material-icons rating-table-data-icon"
                        [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                    </div>
                  </div>
                  <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                    <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                          (click)="selectLetter(rowId, letter)">
                          <span class="blue cp">{{ letter.letterName }}</span>
                        </ion-col>
                      </ion-row>
                    </div>
                  </mat-menu>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- only Rating -->
          <table class="rating-table" *ngIf="onVisibleRatingsData">
            <thead>
              <tr>
                <th *ngFor="let data of getRatingTableData" class="fs-14 font_bold cl-black">{{data.rating | titlecase}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td *ngFor="let data of getRatingTableData; let colId = index">
                  <div class="rating-table-data">
                    <u (click)="onClickAddLetter(0, colId, '', '', data.ratingId, letterNames[colId])">
                      {{ letterNames[0] && letterNames[0][colId] ? letterNames[0][colId] : '+ Add Letter' }}
                    </u>
                    <div>
                      <span *ngIf="letterNames[0] && letterNames[0][colId]"
                        (click)="removeLetter(0, 0, colId, letterNames[0][colId])"
                        class="fs-16 mr-10 material-icons">close</span>
                      <span class="fs-20 material-icons rating-table-data-icon"
                        [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                    </div>
                  </div>
                  <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                    <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                          (click)="selectRatingLetter(0, colId, letter)">
                          <span class="blue cp">{{ letter.letterName }}</span>
                        </ion-col>
                      </ion-row>
                    </div>
                  </mat-menu>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- <table class="rating-table" *ngIf="onVisibleRatingsData">
              <thead>
                <tr>
                  <th *ngFor="let data of getRatingTableData" class="fs-14 font_bold cl-black">
                    {{ data.rating | titlecase }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td *ngFor="let data of getRatingTableData; let colId = index">
                    <div class="rating-table-data">
                      <u (click)="onCLickLetterSave(data.incrementLetterTemplateId?.letterName, data.incrementLetterTemplateId?.subject,
                      data.incrementLetterTemplateId?.body, '', '', data.ratingId, data.id)">
                          {{data.incrementLetterTemplateId?.letterName || '+ Add Letter'}}
                      </u>
                      <span class="fs-20 material-icons" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getRatingTableData">
                        <ion-row>
                          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" 
                            (click)="selectRatingLetter(0, colId, letter)">
                            <span class="blue cp">{{letter.incrementLetterTemplateId?.letterName}}</span>
                          </ion-col>
                        </ion-row>
                      </div>
                    </mat-menu>
                  </td>
                </tr>
              </tbody>
            </table> -->


          <!-- Department and Band -->
          <table class="rating-table" *ngIf="onVisibleDepartmentAndBandData">
            <thead>
              <tr>
                <th>Department</th>
                <th>Band</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <!-- <ng-container *ngFor="let data of getDepartmentAndBandTableData; let rowId = index">
                <tr *ngFor="let band of data.bands; let colId = index">
                  <td *ngIf="colId === 0" [attr.rowspan]="data.bands.length" class="pl-10">{{ data.department }}</td>
                  <td class="pl-10">{{ band }}</td>
                  <td>
                    <div class="rating-table-data">
                      <u (click)="onClickAddLetter(rowId, colId, data.department, band, '')">
                        {{ letterNames[rowId] && letterNames[rowId][colId] ? letterNames[rowId][colId] : '+ Add Letter' }}
                      </u>
                      <div>
                        <span *ngIf="letterNames[rowId]" (click)="removeLetter(rowId, colId, letterNames[rowId])" class="fs-16 mr-10 material-icons">close</span>
                        <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                      </div>
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" (click)="selectRatingLetter(rowId, colId, letter)">
                      <span class="blue cp">{{ letter.letterName }}</span>
                      </ion-col>
                      </ion-row>
                      </div>
                      </mat-menu>
                  </td>
                </tr>
              </ng-container> -->
              <ng-container *ngFor="let data of getDepartmentAndBandTableData; let rowId = index">
                <tr *ngFor="let band of data.bands; let colId = index">
                  <td *ngIf="colId === 0" [attr.rowspan]="data.bands.length" class="pl-10">{{ data.department }}</td>
                  <td class="pl-10">{{ band }}</td>
                  <td>
                    <div class="rating-table-data">
                      <u
                        (click)="onClickAddLetter(rowId, colId, data.department, band, '', letterNames[rowId]?.[colId])">
                        {{ letterNames[rowId] && letterNames[rowId][colId] ? letterNames[rowId][colId] : '+ Add Letter'
                        }}
                      </u>
                      <div>
                        <span *ngIf="letterNames[rowId] && letterNames[rowId][colId]"
                          (click)="removeLetter(rowId, 0, colId, letterNames[rowId][colId])"
                          class="fs-16 mr-10 material-icons">close</span>
                        <span class="fs-20 material-icons rating-table-data-icon"
                          [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                      </div>
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                        <ion-row>
                          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                            (click)="selectRatingLetter(rowId, colId, letter)">
                            <span class="blue cp">{{ letter.letterName }}</span>
                          </ion-col>
                        </ion-row>
                      </div>
                    </mat-menu>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>


          <!-- department and rating -->
          <table class="rating-table" *ngIf="onVisibleDepartmentAndRatingData">
            <thead>
              <tr>
                <th>Department</th>
                <th *ngFor="let data of getRatingTableData" class="fs-14 font_bold cl-black">
                  {{ data.rating | titlecase }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let departmentData of getDepartmentTableData; let rowId = index">
                <td class="pl-10">{{ departmentData }}</td>
                <td *ngFor="let ratingData of getRatingTableData; let colId = index">
                  <div class="rating-table-data">
                    <u
                      (click)="onClickAddLetter(rowId, colId, departmentData, '', ratingData.ratingId, letterNames[rowId]?.[colId])">
                      {{ letterNames[rowId] && letterNames[rowId][colId] ? letterNames[rowId][colId] : '+ Add Letter' }}
                    </u>
                    <div>
                      <span *ngIf="letterNames && letterNames[rowId] && letterNames[rowId][colId]"
                        (click)="removeLetter(rowId, 0, colId, letterNames[rowId][colId])"
                        class="fs-16 mr-10 material-icons">close</span>
                      <span class="fs-20 material-icons rating-table-data-icon"
                        [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                    </div>
                  </div>
                  <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                    <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                          (click)="selectRatingLetter(rowId, colId, letter)">
                          <span class="blue cp">{{ letter.letterName }}</span>
                        </ion-col>
                      </ion-row>
                    </div>
                  </mat-menu>
                </td>
              </tr>
            </tbody>
          </table>


          <!-- band and rating -->
          <table class="rating-table" *ngIf="onVisibleBandAndRatingData">
            <thead>
              <tr>
                <th>Band</th>
                <th *ngFor="let data of getRatingAndBandTableData" class="fs-14 font_bold cl-black">{{data.rating |
                  titlecase}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of getBandAndRatingTableData; let rowId = index">
                <td class="pl-10">{{data}}</td>
                <td *ngFor="let ratingdata of getRatingAndBandTableData; let colId = index">
                  <div class="rating-table-data">
                    <u (click)="onClickAddLetter(rowId, colId, '', data, ratingdata.id, letterNames[rowId]?.[colId])">
                      {{ letterNames[rowId] && letterNames[rowId][colId] ? letterNames[rowId][colId] : '+ Add Letter' }}
                    </u>
                    <div>
                      <span *ngIf="letterNames && letterNames[rowId] && letterNames[rowId][colId]"
                        (click)="removeLetter(rowId, 0, colId, letterNames[rowId][colId])"
                        class="fs-16 mr-10 material-icons">close</span>
                      <span class="fs-20 material-icons rating-table-data-icon"
                        [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                    </div>
                  </div>
                  <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                    <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                          (click)="selectRatingLetter(rowId, colId, letter)">
                          <span class="blue cp">{{ letter.letterName }}</span>
                        </ion-col>
                      </ion-row>
                    </div>
                  </mat-menu>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- department and band and rating -->
          <!-- <table class="rating-table" *ngIf="onVisibleDepartmentAndBandAndRatingData">
            <thead>
            <tr>
            <th>Department</th>
            <th>Band</th>
            <th *ngFor="let data of getRatingTableData" class="fs-14 font_bold cl-black">{{data.rating | titlecase}}</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let data of getDepartmentAndBandTableData; let rowId = index">
            <tr *ngFor="let band of data.bands; let i = index">
            <td *ngIf="i === 0" [attr.rowspan]="data.bands.length" class="pl-10">{{data.department}}</td>
            <td class="pl-10">{{band}}</td>
            <td *ngFor="let rating of getRatingTableData; let colId = index">
            <div class="rating-table-data">
            <u (click)="onClickAddLetter(rowId, colId, data.department, band, rating.ratingId)">
            {{ letterNames[rowId] && letterNames[rowId][colId] ? letterNames[rowId][colId] : '+ Add Letter' }}
            </u>
            <div>
              <span  *ngIf="letterNames && letterNames[rowId] && letterNames[rowId][colId]" (click)="removeLetter(rowId, colId, letterNames[rowId][colId])" class="fs-16 mr-10 material-icons">close</span>
              <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
            </div>
            </div>
            <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
            <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
            <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" (click)="selectRatingLetter(rowId, colId, letter)">
            <span class="blue cp">{{ letter.letterName }}</span>
            </ion-col>
            </ion-row>
            </div>
            </mat-menu>
            </td>
            </tr>
            </ng-container>
            </tbody>
            </table> -->

          <table class="rating-table" *ngIf="onVisibleDepartmentAndBandAndRatingData">
            <thead>
              <tr>
                <th>Department</th>
                <th>Band</th>
                <th *ngFor="let data of getRatingTableData" class="fs-14 font_bold cl-black">{{ data.rating | titlecase
                  }}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let data of getDepartmentAndBandTableData; let rowId = index">
                <tr *ngFor="let band of data.bands; let i = index">
                  <td *ngIf="i === 0" [attr.rowspan]="data.bands.length" class="pl-10">{{ data.department }}</td>
                  <td class="pl-10">{{ band }}</td>
                  <td *ngFor="let rating of getRatingTableData; let colId = index">
                    <div class="rating-table-data">
                      <u
                        (click)="onClickAddDeptBandRatingLetter(rowId, i, colId, data.department, band, rating.ratingId, letterNames[rowId]?.[i]?.[colId])">
                        {{ letterNames[rowId] && letterNames[rowId][i] && letterNames[rowId][i][colId] ?
                        letterNames[rowId][i][colId] : '+ Add Letter' }}
                      </u>
                      <div>
                        <span
                          *ngIf="letterNames && letterNames[rowId] && letterNames[rowId][i] && letterNames[rowId][i][colId]"
                          (click)="removeLetter(rowId, i, colId, letterNames[rowId][i][colId])"
                          class="fs-16 mr-10 material-icons">close</span>
                        <span class="fs-20 material-icons rating-table-data-icon"
                          [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                      </div>
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                        <ion-row>
                          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"
                            (click)="selectDeptAndBandAndRatingLetter(rowId, i, colId, letter)">
                            <span class="blue cp">{{ letter.letterName }}</span>
                          </ion-col>
                        </ion-row>
                      </div>
                    </mat-menu>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="isIncrementLetterCreateContent">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <p class="promotion-content">Promotion Content</p>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="isIncrementLetterCreateContent">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <mat-form-field class="w-100  mat-input-style">
          <textarea matInput [(ngModel)]="IncrementLetterPromotionContent" placeholder="Description"
            rows="5" maxlength="255"
            ></textarea>
            <mat-hint align="end">
              {{ IncrementLetterPromotionContent?.length || 0 }}/255
            </mat-hint>  
        </mat-form-field>
        <label *ngIf="isInValidIncrementLetterDescription" class="red-cl font_regular fs-12">
          Enter Description
        </label>
      </ion-col>
    </ion-row>
  </div>

  <div class="modal-footer" *ngIf="isIncrementLetterCreateContent">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="footer-btn-group">
          <button class="cancleBtn" (click)="getIncrementLettersCompanyData()">Cancel</button>
          <button class="saveBtn" [style.background-color]="buttonColorName" (click)="onClickIncrementLetterSave()"
            [disabled]="isDisabledIncrementLetter" [ngClass]="{ 'disable': isDisabledIncrementLetter }">Save</button>
        </div>
      </ion-col>
    </ion-row>
  </div>
</ion-content>